"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var GetBlockModels_1 = require("@CommonFrontendBackend/BlockModels/GetBlockModels");
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var DefaultCurrency_1 = require("QuoteV2/DefaultCurrency");
var TelemetryEnums_1 = require("Telemetry/TelemetryEnums");
var CleanJson_1 = __importDefault(require("../../../CommonFrontend/CleanJson/CleanJson"));
var SavedBlockService = (function () {
    function SavedBlockService(telemetry, savedBlockDataStore, utils, $log, notifyUser, savedBlockApiService, permissionsService, modal, addDefaultTcdcStyle) {
        var _this = this;
        this.telemetry = telemetry;
        this.savedBlockDataStore = savedBlockDataStore;
        this.utils = utils;
        this.$log = $log;
        this.notifyUser = notifyUser;
        this.savedBlockApiService = savedBlockApiService;
        this.permissionsService = permissionsService;
        this.modal = modal;
        this.addDefaultTcdcStyle = addDefaultTcdcStyle;
        this.onConfirmDelete = function (blockId) { return __awaiter(_this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.savedBlockApiService.delete(blockId)];
                    case 1:
                        _a.sent();
                        this.savedBlockDataStore.deleteById(blockId);
                        return [2, true];
                    case 2:
                        err_1 = _a.sent();
                        this.$log.error(err_1);
                        this.notifyUser.error("Error deleting saved block.");
                        return [2, false];
                    case 3: return [2];
                }
            });
        }); };
        this.bulkDelete = function (blockIds) { return __awaiter(_this, void 0, void 0, function () {
            var err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.savedBlockApiService.bulkDelete(blockIds)];
                    case 1:
                        _a.sent();
                        blockIds.forEach(function (id) { return _this.savedBlockDataStore.deleteById(id); });
                        return [2, true];
                    case 2:
                        err_2 = _a.sent();
                        this.$log.error(err_2);
                        this.notifyUser.error("Error deleting saved block.");
                        return [2, false];
                    case 3: return [2];
                }
            });
        }); };
        this.onConfirmBulkDelete = function (blockIds) { return __awaiter(_this, void 0, Promise, function () {
            var isEditingLockedToAdmins, explainer, didDeleteSuccessfully;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isEditingLockedToAdmins = blockIds.some(function (id) { return _this.savedBlockDataStore.blockEditingLockedToAdmins(id); });
                        explainer = isEditingLockedToAdmins
                            ? "Pages using this saved block won’t be affected, but this saved block will be removed from your library. Blocks created from this saved block will be editable once this saved block is deleted."
                            : "Pages using this saved block won’t be affected, but this saved block will be removed from your library.";
                        return [4, this.modal.showDeleteModal({
                                title: "Delete ".concat(blockIds.length, " saved blocks?"),
                                explainer: explainer,
                                confirmLabel: "Delete",
                                confirming: function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4, this.bulkDelete(blockIds)];
                                            case 1: return [2, _a.sent()];
                                        }
                                    });
                                }); },
                            })];
                    case 1:
                        didDeleteSuccessfully = _a.sent();
                        if (didDeleteSuccessfully) {
                            this.notifyUser.success("Saved blocks deleted");
                        }
                        return [2, didDeleteSuccessfully];
                }
            });
        }); };
        this.delete = function (blockId) { return __awaiter(_this, void 0, Promise, function () {
            var isEditingLockedToAdmins, explainer, didDeleteSuccessfully;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isEditingLockedToAdmins = this.savedBlockDataStore.blockEditingLockedToAdmins(blockId);
                        explainer = isEditingLockedToAdmins
                            ? "Pages using this saved block won’t be affected, but this saved block will be removed from your library. Blocks created from this saved block will be editable once this saved block is deleted."
                            : "Pages using this saved block won’t be affected, but this saved block will be removed from your library.";
                        return [4, this.modal.showDeleteModal({
                                title: "Delete this saved block?",
                                explainer: explainer,
                                confirmLabel: "Delete",
                                confirming: function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4, this.onConfirmDelete(blockId)];
                                            case 1: return [2, _a.sent()];
                                        }
                                    });
                                }); },
                            })];
                    case 1:
                        didDeleteSuccessfully = _a.sent();
                        if (didDeleteSuccessfully) {
                            this.notifyUser.success("Saved block deleted");
                        }
                        return [2, didDeleteSuccessfully];
                }
            });
        }); };
        this.clone = function (blockData) {
            var newBlock = (0, lodash_1.cloneDeep)(blockData);
            newBlock = _this.addNewBlockData(newBlock, "Cloned From: ".concat(newBlock.savedBlockName));
            return _this.saveBlock(newBlock);
        };
        this.update = function (block, origin) {
            if (origin === void 0) { origin = TelemetryEnums_1.SavedBlockOrigin.Editor; }
            return __awaiter(_this, void 0, Promise, function () {
                var cleanedBlock, response, updatedSavedBlock, result, err_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            cleanedBlock = (0, CleanJson_1.default)(block);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, this.savedBlockApiService.update(cleanedBlock)];
                        case 2:
                            response = _a.sent();
                            updatedSavedBlock = response.data.message;
                            if (!updatedSavedBlock) {
                                this.notifyUser.error("Can't update a block that has been deleted");
                                return [2];
                            }
                            updatedSavedBlock.$editingLockedToAdmins = block.$editingLockedToAdmins;
                            updatedSavedBlock.$editable = block.$editable;
                            result = this.savedBlockDataStore.update(updatedSavedBlock);
                            if (result.isNameChanged) {
                                this.telemetry.track("Saved Block Renamed", { saved_block_origin: origin }, { blockIntercom: true });
                            }
                            return [3, 4];
                        case 3:
                            err_3 = _a.sent();
                            this.$log.error(err_3);
                            this.notifyUser.error("There was an error updating the block.");
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        };
        this.createDefaults = function () { return __awaiter(_this, void 0, Promise, function () {
            var response, newSavedBlocks, newSavedBlocks_1, newSavedBlocks_1_1, newSavedBlock, err_4;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4, this.savedBlockApiService.createDefaults()];
                    case 1:
                        response = _b.sent();
                        newSavedBlocks = response.data.message;
                        try {
                            for (newSavedBlocks_1 = __values(newSavedBlocks), newSavedBlocks_1_1 = newSavedBlocks_1.next(); !newSavedBlocks_1_1.done; newSavedBlocks_1_1 = newSavedBlocks_1.next()) {
                                newSavedBlock = newSavedBlocks_1_1.value;
                                this.savedBlockDataStore.add(newSavedBlock);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (newSavedBlocks_1_1 && !newSavedBlocks_1_1.done && (_a = newSavedBlocks_1.return)) _a.call(newSavedBlocks_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [3, 3];
                    case 2:
                        err_4 = _b.sent();
                        this.$log.error(err_4);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        this.setLockEditingSetting = function (blockId, newState) { return __awaiter(_this, void 0, Promise, function () {
            var err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!blockId) {
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.permissionsService.setLockEditingSettingForSavedBlock(blockId, newState)];
                    case 2:
                        _a.sent();
                        this.savedBlockDataStore.setLockEditingSetting(blockId, newState);
                        return [3, 4];
                    case 3:
                        err_5 = _a.sent();
                        this.$log.error(err_5);
                        this.notifyUser.error("There was an error updating whether the saved block can be edited by all users; refresh the page and try again.");
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); };
        this.recordUsage = function (savedBlockId) { return __awaiter(_this, void 0, Promise, function () {
            var response, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.savedBlockApiService.recordUsage(savedBlockId)];
                    case 1:
                        response = _a.sent();
                        this.savedBlockDataStore.recordUsage(savedBlockId, response.data.message);
                        return [3, 3];
                    case 2:
                        err_6 = _a.sent();
                        this.$log.error(err_6);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        this.save = function (block, saveAs) {
            var data = _this.addNewBlockData(block, saveAs);
            return _this.saveBlock(data);
        };
        this.saveNewInitialisedBlock = function (blockModel) { return __awaiter(_this, void 0, Promise, function () {
            var savedBlock;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.saveBlock(blockModel)];
                    case 1:
                        savedBlock = _a.sent();
                        return [2, savedBlock];
                }
            });
        }); };
        this.initialiseNewSavedBlock = function (blockType) {
            var blockModel = (0, GetBlockModels_1.getBlockModel)(blockType);
            _this.addDefaultTcdcStyle(blockModel);
            _this.addNewBlockData(blockModel);
            return blockModel;
        };
        this.saveBlock = function (blockData) { return __awaiter(_this, void 0, Promise, function () {
            var response, component, err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        blockData = (0, CleanJson_1.default)(blockData);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.savedBlockApiService.create(blockData)];
                    case 2:
                        response = _a.sent();
                        component = response.data.message;
                        if (component == null) {
                            throw new Error("Save Block request returned null response");
                        }
                        this.savedBlockDataStore.add(component);
                        return [2, component];
                    case 3:
                        err_7 = _a.sent();
                        this.$log.error(err_7);
                        return [2, this.notifyUser.error("There was an error saving the block.")];
                    case 4: return [2];
                }
            });
        }); };
        this.addNewBlockData = function (blockData, saveAs) {
            if (saveAs == null) {
                saveAs = "Untitled";
            }
            blockData.savedBlockName = saveAs;
            if (blockData.type === "module") {
                blockData.moduleName = blockData.__t;
            }
            blockData.id = _this.utils.uniqueId(22);
            if (blockData.settings == null) {
                blockData.settings = {};
            }
            if (blockData.settings.navigation == null) {
                blockData.settings.navigation = { exclude: false };
            }
            if (blockData.type === BlockTypes_1.BlockType.Quote && blockData.settings.currency == null) {
                blockData.settings.currency = (0, DefaultCurrency_1.getDefaultCurrency)();
            }
            return blockData;
        };
    }
    return SavedBlockService;
}());
exports.default = SavedBlockService;
